module.exports = __webpack_public_path__ + "static/media/vtsl_logo_black.e3c85236.png";